import { Component } from '@angular/core';
import { NavParams, ViewController, ModalController } from 'ionic-angular';

/*
  Generated class for the ModalAdicionarPergunta page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
    selector: 'page-modal-responsavel-tce',
    templateUrl: 'modal-responsavel-tce.html'
})
export class ModalResponsavelTcePage {
    objetoTCE: any = {
        "idResponsavel": 0,
        "nomeResponsavel": "",
        "cpf": ""
    };

    codigoModulo: any = null;

    objetoRetorno: any = {
        salvar: false,
        periodoFuncao: ''
    };

    cpfMask = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];

    cpfPreenchido: boolean = false;
    cpfCarregado: boolean = true;
    cpfInvalido: boolean = false;

    user: any;

    tce: any;
    isJurisdicionado: any;
    isCGE: any;

    constructor(private viewCtrl: ViewController,
        public modalCtrl: ModalController,
        public navParams: NavParams) {

        this.objetoRetorno = {
            salvar: false,
            tce: ""
        };

        this.tce = this.navParams.get('tce');
        this.isJurisdicionado = this.navParams.get('jurisdicionado');
        this.isCGE = this.navParams.get('isCGE');
    }

    adicionarResponsavel() {
        if (this.objetoTCE.nomeResponsavel != '' &&
            this.objetoTCE.cpf != '') {

            let respNovo = {
                "idResponsavel": 0,
                "nomeResponsavel": this.objetoTCE.nomeResponsavel,
                "cpf": this.objetoTCE.cpf.replace(/\D/g, '')
            };

            this.tce.responsaveis.push(respNovo);

            this.objetoTCE.nomeResponsavel =
                this.objetoTCE.cpf = '';
        }
    }

    removerResponsavel(resp) {
        let index = this.tce.responsaveis.indexOf(resp);
        this.tce.responsaveis.splice(index, 1);
    }

    dismiss() {
        this.objetoRetorno.salvar = false;
        this.viewCtrl.dismiss(this.objetoRetorno);
    }

    salvarEdicao() {
        this.objetoRetorno.salvar = true;
        this.objetoRetorno.tce = this.tce;
        this.viewCtrl.dismiss(this.objetoRetorno);
    }

    editar(item) {
        this.objetoTCE.nomeResponsavel = item.nomeResponsavel;
        this.objetoTCE.cpf = item.cpf;

        this.removerResponsavel(item);
    }

    onCPFAlterado() {
        if (this.validarCPF(this.objetoTCE.cpf)) {
            this.cpfInvalido = false;
        }
        else {
            this.cpfPreenchido = false;
        }
    }

    cpf_mask(v) {
        v = v.replace(/\D/g, ''); //Remove tudo o que não é dígito
        v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
        v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
        //de novo (para o segundo bloco de números)
        v = v.replace(/(\d{3})(\d{1,2})$/, '$1-$2'); //Coloca um hífen entre o terceiro e o quarto dígitos
        return v;
    }

    validarCPF(cpf) {
        let ehValido = true;

        cpf = cpf.replace(/[^\w\s]/gi, '');

        if (cpf == '') {
            this.cpfInvalido = false;
            return false;
        }

        if (cpf.length != 11) {
            this.cpfInvalido = false;
            return false;
        }

        // Elimina CPFs invalidos conhecidos  
        if (cpf == "00000000000" || cpf == "11111111111" || cpf == "22222222222" ||
            cpf == "33333333333" || cpf == "44444444444" || cpf == "55555555555" ||
            cpf == "66666666666" || cpf == "77777777777" || cpf == "88888888888" || cpf == "99999999999") {
            this.cpfInvalido = true;
            return false;
        }

        // Valida 1o digito 
        let add = 0;
        for (let i = 0; i < 9; i++)
            add += parseInt(cpf.charAt(i)) * (10 - i);
        let rev = 11 - (add % 11);
        if (rev == 10 || rev == 11)
            rev = 0;
        if (rev != parseInt(cpf.charAt(9))) {
            this.cpfInvalido = true;
            return false;
        }

        // Valida 2o digito 
        add = 0;
        for (let i = 0; i < 10; i++) {
            add += parseInt(cpf.charAt(i)) * (11 - i);
        }
        rev = 11 - (add % 11);
        if (rev == 10 || rev == 11)
            rev = 0;
        if (rev != parseInt(cpf.charAt(10))) {
            this.cpfInvalido = true;
            return false;
        }

        return ehValido;
    }

}



// WEBPACK FOOTER //
// ./src/pages/modais/modal-responsavel-tce/modal-responsavel-tce.ts